import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import FilteringSidePanel from "../../../../../shared/oversight-core/shared-components/filtering-side-panel/filtering-side-panel";
import ArrowButton from "../../../../../shared/oversight-core/ui-elements/arrow-button/arrow-button";
import ButtonWithBadge from "../../../../../shared/oversight-core/ui-elements/buttons/button-with-badge/button-with-badge";
import AuctionContract from "../auction-contract/auction-contract";

interface IProps {
  setSelectedButton: React.Dispatch<React.SetStateAction<number>>;
}

const AuctionContracts = (props: IProps) => {
  const { setSelectedButton } = props;
  const [isShowFilteringSidePanel, setIsShowFilteringSidePanel] =
    useState(false);
  return (
    <>
      <Row className="align-items-center">
        <Col className="col-auto">
          <ArrowButton onBack={() => setSelectedButton(0)} />
        </Col>
        <Col
          className="font-weight-500 text-dark cursor-pointer"
          onClick={() => {
            setSelectedButton(0);
          }}
        >
          Auction
        </Col>
        <Col className="col-auto px-0">
          <ButtonWithBadge
            text="Filter"
            icon="filter_alt"
            onClick={() => {
              setIsShowFilteringSidePanel(true);
            }}
          />
        </Col>
      </Row>
      <Row className="mt-4">
        <Col className="px-0">
          <AuctionContract isAlreadyBid={true} />
        </Col>
      </Row>
      <Row className="mt-4">
        <Col className="px-0">
          <AuctionContract />
        </Col>
      </Row>
      <FilteringSidePanel
        isOpen={isShowFilteringSidePanel}
        onClose={() => {
          setIsShowFilteringSidePanel(false);
        }}
        onFilter={() => {
          setIsShowFilteringSidePanel(false);
        }}
      />
    </>
  );
};

export default AuctionContracts;
